import capitalize from 'lodash/capitalize';

const capitalizeWords = (text) =>
  text.replace(/\b(?![a-zA-Z]\.)[a-zA-Z\u00C0-\u017F]+(?:[^\w\s][a-zA-Z\u00C0-\u017F]+)*/g, (word) =>
    word.replace(/^[a-zA-Z\u00C0-\u017F]+/, capitalize)
  );

export default capitalizeWords;



// WEBPACK FOOTER //
// ./src/modules/utils/capitalize-words.js